<template>
  <div>
    <b-row
      ><b-card
        no-body
        style="width:140px; cursor: pointer; background-color:#f3f3f3; margin-bottom:1rem"
        class="ml-1"
        @click="showRecibo"
      >
        <b-row class="mr-0 ml-0 rounded-top bg-primary" style="color:white">
          <b-col md="6" class="p-0">
            <b style="font-size:10px; margin-left:3px"
              >{{ partido.categoria }}
            </b>
          </b-col>
          <b-col md="6">
            <span style="font-size:11px">{{ partido.horario }}</span>
          </b-col>
        </b-row>
        <b-row style="padding:3px">
          <b-col md="5" style="margin-left:16px;font-size:11px" class="p-0">
            {{ partido.local }}
          </b-col>
          <b-col
            md="5"
            style="font-size:11px"
            :class="partido.bloquear_local == 's' ? 'pagada' : 'no-pagada'"
          >
            <b v-if="partido.id_recibo_local != null"
              >{{ partido.total_local }}$</b
            >
            <b v-else>-</b>
          </b-col>
        </b-row>
        <div
          style="border-bottom: 1px solid #e0e0e0;margin-top:2px; margin-bottom:2px"
        ></div>
        <b-row style="padding:3px">
          <b-col md="5" style="margin-left:16px;font-size:11px" class="p-0">
            {{ partido.visita }}
          </b-col>
          <b-col
            md="5"
            style="font-size:11px"
            :class="partido.bloquear_visita == 's' ? 'pagada' : 'no-pagada'"
          >
            <b v-if="partido.id_recibo_visita != null"
              >{{ partido.total_visita }}$</b
            >
            <b v-else>-</b>
          </b-col>
        </b-row>
      </b-card></b-row
    >
  </div>
</template>
<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
// import store from '@/store'

export default {
  components: {
    BRow,
    BCol,
    BCard,
  },
  props: {
    partido: Object,
  },
  setup(props, { emit }) {
    function showRecibo() {
      // console.log(props.partido)
      emit('clickPartido', props.partido)
      // store.commit('someVariables/UPDATE_SHOW_RECIBO', true)
    }
    return {
      showRecibo,
    }
  },
}
</script>
<style>
.pagada {
  color: darkgreen;
  display: flex;
  align-items: center;
}
.no-pagada {
  color: red;
  display: flex;
  align-items: center;
}
</style>
